module.exports = __webpack_public_path__ + "static/media/fondo2.8f47fa37.jpg";